import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { CentroCustoCadastro } from 'src/app/models/centro-custo-cadastro';
import { Auth } from 'src/app/models/auth';
import { Subscription } from 'rxjs';
import { CentroCusto } from 'src/app/models/centro-custo';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { StatusCadastro } from 'src/app/shared/enums/status-cadastro.enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-centro-custo-edit',
    templateUrl: './centro-custo-edit.component.html',
    styleUrls: ['./centro-custo-edit.component.css']
})
export class CentroCustoEditComponent implements OnInit, OnDestroy {

    private currentUser: Auth;
    public centroCustoCadastro: CentroCustoCadastro;

    public centroCustoFormGroup: FormGroup;
    public canEdit = false;

    private centroCusto: CentroCusto;
    private id: number;
    private routeSubscription: Subscription;
    public StatusCadastro = StatusCadastro;

    ngOnInit() {
        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.id = +params.get('id');
        });

        this.currentUser = this.authenticationService.currentUserValue;

        // usar para criar / editar
        this.createForm(new CentroCustoCadastro('', '', '', ''));
        // validar se foi para esse componente com o id do centro de custo (sim = editar) (não = cadastrar)
        this.centroCustoService.getById(this.id, this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.centroCusto = response.result;
                this.createForm(this.centroCusto);
                this.canEdit = true;
            },
            error => {
                this.alertService.error('Não foi possível encontrar o centro de custo.');
                this.router.navigate(['list'], { relativeTo: this.route.parent });
            }
        );

    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    constructor(
        private formBuilder: FormBuilder,
        private centroCustoService: CentroCustoService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router, private route: ActivatedRoute) {
    }

    public get form() {
        return this.centroCustoFormGroup.controls;
    }

    createForm(centroCustoCadastro: CentroCustoCadastro) {
        this.centroCustoFormGroup = this.formBuilder.group({
            nome: new FormControl(centroCustoCadastro.nome, [
                Validators.required,
                Validators.maxLength(100)
            ]),
            codigo: new FormControl(centroCustoCadastro.codigo, [
                Validators.required,
                Validators.maxLength(15)
            ]),
            nomeResponsavel: new FormControl(centroCustoCadastro.nomeResponsavel, [
                Validators.maxLength(100)
            ]),
            emailResponsavel: new FormControl(centroCustoCadastro.emailResponsavel, [
                Validators.maxLength(100),
                Validators.email
            ]),
            status: new FormControl(centroCustoCadastro.status, [

            ])
        });
    }

    onSubmit(centroCustoCadastro: CentroCustoCadastro) {
        if (this.centroCustoFormGroup.valid) {
            this.centroCustoService
                .update(this.id, centroCustoCadastro, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success(response.message, true);
                            this.router.navigate(['list'], { relativeTo: this.route.parent });
                        } else {
                            this.alertService.error(response.message);
                        }
                    }
                );
        } else {
            GenericValidator.verifierValidatorsForm(this.centroCustoFormGroup);
        }
    }

}
